const ISSUES_ROUTE = '/issues'


const Routes = {
    ISSUES_ROUTE,
};
export default Routes;
